<div class="container-fluid h-100 readOnlyForm pl-0 pr-0">
  <!-- Section header start -->

  <div class="headerBackground card p-1 mb-2 tool-header-height">
    <div class="row padding2px">
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 sectionHeaderIcon">
        <span>
          <fa-icon class="fas fa-lg autoCursor" [icon]="faUser"></fa-icon>
        </span>
      </div>
      <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-4">
        <h6 class="headerFontSize">Jira Testing</h6>
      </div>
      <div class="col col-7 col-md-7 col-lg-7 col-sm-7 col-xs-6">
        <p class="titleParagraph">Jira Testing toolHeaderLine1<br>
          Jira Testing toolHeaderLine2
        </p>
      </div>
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1">
        <table class="dropGroupBtn">
          <tr>
            <td class="iconGroupHeight">
              <span>
                <a type="button" class="" data-toggle="modal" data-target="#ytVideoLinkPM">
                  <fa-icon class="fas" [icon]="faInfoCircle" title="help"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
            </td>
          </tr>
          <tr class="bg-color-black">
            <td class="height25px">
              <span>
                <fa-icon class="fas margintop7pxminus" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <!-- Section header end -->
  <div class="persona-mapper tool-body-height">
    <div class="card p-1 mb-2 bg-black h-100" style="color: white;">
      <div class="persona-mapper-table-height">
        <div>Projects List</div>
        <div *ngFor="let p of jiraProjectList; let tabIndex = index">
          {{tabIndex+1}}. {{p.name}}
        </div>
        <div>
          <div>Jira user stories</div>
          <table class="table table-bordered w-100">
            <thead>
              <th>S.No</th>
              <th>Project Name</th>
              <th>Issue Type</th>
              <th>Issue Desc</th>
              <th>Key</th>
              <th>Id</th>
              <th>Created date</th>
              <th>Created by</th>
              <th>Assignee</th>
              <th>Status</th>
              <th>Summary</th>
            </thead>
            <tbody>
              <tr *ngFor="let q of jiraStoriesList; let tabIndex = index">
                <td>{{tabIndex+1}}</td>
                <td>{{q.fields.project.name}}</td>
                <td>{{q.fields.issuetype.name}}</td>
                <td>{{q.fields.issuetype.description}}</td>
                <td>{{q.key}}</td>
                <td>{{q.id}}</td>
                <td>{{q.fields.created | date}}</td>
                <td>{{q.fields.creator.displayName}}</td>
                <td>{{q.fields.assignee.displayName}}</td>
                <td>{{q.fields.status.name}}</td>
                <td>{{q.fields.summary}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- Section footer start -->
  <div class="headerBackground card p-1 mt-2 tool-footer-height">
    <div class='row pb-0 pt-0'>
      <div id="personamapperTip" class="carousel slide" data-ride="carousel" data-interval="false"
        data-interval="false">
        <div class="carousel-inner text-color-yellow">
          <div class="row item active text-color-yellow">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #1 : tip1 text
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #2 : tip2 text
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #3 : tip3 text
            </div>
          </div>
        </div>
        <a class="left carousel-control carousel-tip-align display-flex" data-target="#personamapperTip"
          data-slide="prev">
          <span>
            <fa-icon class="fas" [icon]="faChevronLeft"></fa-icon>
          </span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control carousel-tip-align display-flex" data-target="#personamapperTip"
          data-slide="next">
          <span>
            <fa-icon class="fas" [icon]="faChevronRight"></fa-icon>
          </span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
  <!-- Section footer end -->
</div>